export default __webpack_public_path__ + "img/4f5399ca9f41ac7cb1c6a9267e20db4c.jpg";